import React from "react";
import { education } from "../../data/education";
import { nodeId } from "../../data/connections";
import EvidenceCard from "../../components/investigation/EvidenceCard";
import EvidenceImage from "../../components/investigation/EvidenceImage";
import CaseStamp from "../../components/investigation/CaseStamp";
import { detailFromEducation } from "../../utils/evidenceDetail";

export const EducationSection = () => (
  <div className="education-cluster">
    <div className="evidence-group-row education-row">
      {education.map((item, index) => (
        <EvidenceCard
          key={item.id}
          variant={item.primary ? "diploma" : "paper"}
          pin={item.primary ? "brass" : "black"}
          rotate={index === 1 ? 1.2 : -0.8}
          className="edu-evidence"
          nodeId={nodeId.school(item.id)}
          detail={detailFromEducation(item)}
        >
          <p className="case-kicker">Record {item.evidenceNo}</p>
          <EvidenceImage src={item.logo} alt="" variant="logo" pin={false} placeholderLabel="SCHOOL MARK" />
          <h3>{item.degree}</h3>
          <p>{item.university}</p>
          <p className="timeline-dates">{item.duration}</p>
          {item.primary ? (
            <CaseStamp tone="ink" rotate={-5} className="tiny-stamp">
              {item.status}
            </CaseStamp>
          ) : (
            <p className="timeline-dates">{item.status}</p>
          )}
          <a href={item.link} target="_blank" rel="noreferrer" className="exhibit-link">
            verify source ↗
          </a>
        </EvidenceCard>
      ))}
    </div>
  </div>
);

export default EducationSection;
